import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

interface PdfViewerProps {
  pdfUrl: string;
  width?: string;
  height?: string;
  borderColor?: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({
  pdfUrl,
  width = "685px",
  height = "500px",
  borderColor = "gray",
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width,
          height,
          margin: "auto",
          border: `3px solid ${borderColor}`,
        }}
      >
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
          <Viewer fileUrl={pdfUrl} />
        </Worker>
      </div>
    </div>
  );
};

export default PdfViewer;
